import { proxy } from "valtio";

export const mobileNavBarState = proxy({
    visible: true
})


